module.exports = __webpack_public_path__ + "static/media/Arrow-left-white.3583ae88.svg";